module.exports = __webpack_public_path__ + "img/Online-report-pana.5da1bea7.png";